import React,{useState,useEffect} from "react";

const Add_Student_Mark = ()=>{
    return(
        <div>
            
            hai
        </div>
    )
}

export default Add_Student_Mark